import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookie is set by backend on login/register/session.
// withCredentials ensures browser sends the cookie on every /api request.
// X-Requested-By is a lightweight CSRF mitigation — attackers can't set custom headers via CSRF.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-By": "ExamBro" },
});
